import styled from '@emotion/styled'
import { StyledWrapper as VideoStyledWrapper } from '../../content/Video/Video.styled'
import {
    breakpoint,
    calcRem,
    colors,
    fonts,
    themedValue,
} from '../../__styling'
import { Product, createPropFilter } from '@news-mono/web-common'
import { StyledSharing } from '../../buttons/Sharing/Sharing.styled'

export const StyledWrapper = styled(VideoStyledWrapper)(({}) => ({
    display: 'flex',
    flexDirection: 'row',
}))

interface StyledSharingWrapProp {
    className?: string
}

export const StyledSharingWrap = styled('span', {
    shouldForwardProp: createPropFilter<StyledSharingWrapProp>()(['className']),
})<StyledSharingWrapProp>(({ theme }) => {
    return {
        color: theme.sectionValues.primaryColor,
        fontWeight: 500,
        fontSize: calcRem(12),
        display: 'flex',
        justifyContent: 'flex-start',

        [`${StyledSharing}`]: {
            '&::before': {
                display: 'none',
            },
        },

        [breakpoint('md')]: {
            marginBottom: calcRem(0),
        },

        ['.BauhausCardSharing']: {
            marginBottom: calcRem(0),

            [`.gtm-facebook-share-button svg`]: {
                top: '50%',
                transform: `translate(-57%, -50%)`,
            },
            ['.gtm-facebook-share-button, .gtm-twitter-share-button, .gtm-email-share-button, .gtm-clipboard-share-button']:
                {
                    ['svg']: {
                        fill: colors.white,
                    },
                },
        },
    }
})

export const StyledVideoPlayerByline = styled('div')(({ theme }) => ({
    fontSize: calcRem(12),
    fontFamily: fonts.sevennews.sansSerif,
    marginTop: 0,
    position: 'relative',
    display: theme.kind === Product.SevenNews ? undefined : 'none',
    fontWeight: 400,
    [breakpoint('md')]:
        theme.kind === Product.PerthNow
            ? undefined
            : {
                  position: 'absolute',
                  bottom: 0,
              },
    span: {
        color: colors.sevennews.dustyGray,
        margin: calcRem(0, 3),
    },
    [`${StyledSharingWrap}`]: {
        display: 'inline-block',
        position: 'absolute',
        bottom: themedValue(theme, {
            fallback: calcRem(-24),
            sevennews: calcRem(-32),
        }),

        [breakpoint('sm')]: {
            position: 'unset',
            verticalAlign: 'middle',
        },

        [`${StyledSharing}`]: {
            marginLeft: 0,

            '&::before': {
                display: 'none',
            },

            '& > button': {
                marginRight: calcRem(10),
                marginLeft: 0,
                // background: 'none',
                // svg: {
                //     fill: theme.sectionValues.primaryColor,
                // },
            },

            '& > button.gtm-clipboard-share-button:active:before': {
                opacity: 1,
                transition: '0s',
            },
            '& > button.gtm-clipboard-share-button:before': {
                position: 'absolute',
                top: calcRem(-35),
                left: calcRem(-31),
                width: calcRem(98),
                opacity: 0,
                padding: calcRem(6),
                content: '"✓ Link Copied "',
                transition: 'opacity 1.7s cubic-bezier(.0,.05,1,-0.24)',
                fontFamily: theme.fonts.sansSerif,
                fontSize: calcRem(12),
                fontWeight: 600,
                background: theme.colors.palette.black,
                color: theme.colors.palette.white,
                pointerEvents: 'none',
            },
        },
    },
}))
